module.exports = __webpack_public_path__ + "static/img/icon_two_months_en.1364cc43.jpg";